import { ApolloClient, ApolloLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import createUploadLink from "apollo-upload-client/createUploadLink.mjs";

import { IS_LOGGED_IN } from "graphql/query/local-store-gql";

import {
    AUTH_TOKEN_STORAGE_KEY,
    createSessionInvalidator,
    shouldInvalidateSession,
} from "./auth-error";
import cache from "./cache";



const httpLink = createUploadLink({
    uri: process.env.REACT_APP_API_ENDPOINT
});


const authLink = setContext((_, { headers }) => {
    const authToken = localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);

    if (!authToken)
    {

        return { headers: { ...headers } };
    }

    return {
        headers: {
            ...headers,
            Accept: "application/json",
            Authorization: `Bearer ${ authToken }`
        }
    };
});

const invalidateSession = createSessionInvalidator({
    getAuthToken: () => localStorage.getItem(AUTH_TOKEN_STORAGE_KEY),
    removeAuthToken: () => localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY),
    markLoggedOut: () => cache.writeQuery({
        query: IS_LOGGED_IN,
        data: {
            isLoggedIn: false,
        },
    }),
    redirectToLogin: () => window.location.replace("/"),
});

const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
    if (shouldInvalidateSession({
        operationName: operation.operationName,
        hasAuthToken: !!localStorage.getItem(AUTH_TOKEN_STORAGE_KEY),
        graphQLErrors,
        networkError,
    })) {
        invalidateSession();
    }
});

const client = new ApolloClient({
    link: ApolloLink.from([ errorLink, authLink, httpLink ]),
    cache
});

cache.writeQuery({
    query: IS_LOGGED_IN,
    data: {
        isLoggedIn: !!localStorage.getItem(AUTH_TOKEN_STORAGE_KEY),
    },
});

export default client;
